import { rpcSlice } from '../../store/api/rpcSlice';

export interface ChatProfile {
  profiles: string[];
}

// Chat API endpoints (mounted under /rpc/v1/chat on backend)
// Note: Stateful POST /chat and /chat/{profile} endpoints have been removed.
// Use createRun from @platform/chat/api/sseClient for stateless chat.
export const chatApi = rpcSlice.injectEndpoints({
  endpoints: (builder) => ({
    listChatProfiles: builder.query<ChatProfile, void>({
      query: () => ({ url: '/chat/profiles' }),
    }),
  }),
});

export const { useListChatProfilesQuery } = chatApi;
